@if (selectedCount > currentViewSelectedCount) {
  <rt-message
    variant="context-information small"
    [attr.margin-bottom]="hasBottomMargin || null"
    [attr.margin-top-medium]="hasTopMarginMedium || null"
  >
    <div class="text">
      @if (currentViewSelectedCount > 0) {
        <div
          [innerHTML]="
            'rtu.common.bulk_select.messages.out_of_view_with_current'
              | translate: { totalCount: selectedCount, visibleCount: currentViewSelectedCount }
          "
        ></div>
      }
      @if (currentViewSelectedCount === 0) {
        <div
          [innerHTML]="
            'rtu.common.bulk_select.messages.out_of_view' | translate: { totalCount: selectedCount }
          "
        ></div>
      }
    </div>
    <rt-button variant="plain" (click)="clearSelection.emit()">
      {{ 'rtu.common.bulk_select.messages.unselect_all' | translate }}
    </rt-button>
  </rt-message>
}
